import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEO from '../../components/feature/SEO';

const sections = [
  {
    title: 'Angaben gemäß § 5 TMG',
    content: (
      <div className="space-y-1 text-gray-600 text-sm leading-relaxed">
        <p className="font-semibold text-gray-900">IGM Facility Service</p>
        <p>Industriestr. 37</p>
        <p>40878 Ratingen</p>
        <p>Deutschland</p>
      </div>
    ),
  },
  {
    title: 'Vertreten durch',
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        Ilker Sahin (Inhaber)
      </p>
    ),
  },
  {
    title: 'Kontakt',
    content: (
      <div className="space-y-2 text-sm">
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-phone-line text-[#0D2B4E]" />
          </div>
          <a href="tel:+4921027398070" className="text-gray-600 hover:text-[#0D2B4E] transition-colors">
            02102 7398070
          </a>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-mail-line text-[#0D2B4E]" />
          </div>
          <a href="mailto:kontakt@igmfacilityservice.de" className="text-gray-600 hover:text-[#0D2B4E] transition-colors">
            kontakt@igmfacilityservice.de
          </a>
        </div>
      </div>
    ),
  },
  {
    title: 'Umsatzsteuer-Identifikationsnummer',
    content: (
      <div className="text-sm text-gray-600 space-y-1">
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
        </p>
        <p className="font-medium text-gray-900">DE 123456789</p>
      </div>
    ),
  },
  {
    title: 'Berufsbezeichnung und berufsrechtliche Regelungen',
    content: (
      <div className="text-sm text-gray-600 space-y-1">
        <p>Berufsbezeichnung: Bauunternehmen / Garten- und Landschaftsbau</p>
        <p>Zuständige Handwerkskammer: Handwerkskammer Düsseldorf</p>
        <p>
          Verliehen in: Deutschland. Es gelten die Handwerksordnung (HwO) sowie die
          einschlägigen VOB-Bestimmungen.
        </p>
      </div>
    ),
  },
  {
    title: 'Streitschlichtung',
    content: (
      <div className="text-sm text-gray-600 space-y-3">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-[#0D2B4E] underline hover:no-underline"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    ),
  },
  {
    title: 'Haftung für Inhalte',
    content: (
      <p className="text-sm text-gray-600 leading-relaxed">
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach
        den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
        jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
        oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen
        zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
        hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
        einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen
        werden wir diese Inhalte umgehend entfernen.
      </p>
    ),
  },
  {
    title: 'Haftung für Links',
    content: (
      <p className="text-sm text-gray-600 leading-relaxed">
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
        haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
        der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
        Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
        Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
        Links umgehend entfernen.
      </p>
    ),
  },
  {
    title: 'Urheberrecht',
    content: (
      <p className="text-sm text-gray-600 leading-relaxed">
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
        deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
        außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
        Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht
        kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
        wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
        gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten
        wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
        derartige Inhalte umgehend entfernen.
      </p>
    ),
  },
];

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO
        title="Impressum | IGM Facility Service"
        description="Impressum und Pflichtangaben gemäß § 5 TMG – IGM Facility Service, Industriestr. 37, 40878 Ratingen."
        robots="noindex, nofollow"
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-28 pb-10 sm:pt-32 bg-[#0D2B4E]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 mb-3">
            <Link to="/" className="text-white/50 text-sm hover:text-white/80 transition-colors">Startseite</Link>
            <span className="text-white/30 text-sm">/</span>
            <span className="text-white/80 text-sm">Impressum</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">Impressum</h1>
          <p className="text-white/70 text-sm">Pflichtangaben gemäß § 5 TMG und § 55 RStV</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-14 bg-[#F8F7F4]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {sections.map((section) => (
              <div
                key={section.title}
                className="bg-white rounded-xl border border-gray-100 p-6 sm:p-7"
              >
                <h2 className="text-base font-bold text-gray-900 mb-3 pb-3 border-b border-gray-100">
                  {section.title}
                </h2>
                {section.content}
              </div>
            ))}
          </div>

          {/* Back to Home */}
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-[#0D2B4E] text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </div>
              Zurück zur Startseite
            </Link>
            <Link
              to="/datenschutz"
              className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 px-6 py-3 rounded-lg font-semibold text-sm hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Datenschutzerklärung
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
